import DropLoad from "../../c/DropLoad/";
import { Col, Container, Row } from "reactstrap";
import { RenderIf } from "../../helpers/RenderIf";
import React, { useState } from "react";
import { RecordAudio } from "./AudioRecorder";
import { Input, TextArea } from "../../c/Input/";
import Dropdown from "../../c/DropDown"
import { T } from "../../traks";

const Header = () => (
	<div>
		<div className="my-4 font_10px txt_grey_3">
			<T>Step 2/2</T>
		</div>
		<h3>
			<T>Submit your issue</T>
		</h3>
	</div>
)

const WhistleContent = ({ whistle, setWhistle }) => (
	<div>
		<TextArea
			className="w-100 border_radius_6px shadow p-3 whistle-content"
			onChange={(e) =>
				setWhistle({
					...whistle,
					content: e
				})
			}
			initValue={whistle.content}
		/>
	</div>
)

const WhistleRecipient = ({ whistle, setWhistle, recipients }) => (
	<div className="my-5">
		<h4><T>Entry recipient</T></h4>
		<Dropdown toggleText={whistle.screen_name || <T>Choose</T>}>
			{recipients.map((recipient, index) => (
				<button
					onClick={() => setWhistle({ ...whistle, ...recipient })}
					key={'d' + index}
				>
					{recipient.screen_name}
				</button>
			))}
			<a
				href={"https://whistleblower.dk/indberet"}
				target="_blank"
				rel="noreferrer"
				className="no-style"
			>
				<T>Datatilsynet</T>
			</a>
		</Dropdown>
	</div>
)


const DropLoadWrapper = ({ children }) => (
	<div className="my-3">
		{children}
	</div>
)

const InputMode = ({ setFiles, whistle, setWhistle }) => {
	const [recordWhistle, setRecordWhistle] = useState(false)
	const [writeWhistle, setWriteWhistle] = useState(true)

	const handleTab = () => {
		setRecordWhistle(!recordWhistle)
		setWriteWhistle(!writeWhistle)
	}

	const audioTabClass = recordWhistle ? " btn_green fw_700" : ""
	const writableTabClass = writeWhistle ? " btn_green fw_700" : ""

	return (
		<>
			<div className={`d-flex my-3`}>
				<div className="me-3">
					<button className={`btn border${audioTabClass}`} onClick={() => handleTab()}>
						<T>record sound</T>
					</button>
				</div >
				<div>
					<button className={`btn border${writableTabClass}`} onClick={() => handleTab()}>
						<T>write entry</T>
					</button>
				</div>
			</div>
			<RenderIf condition={writeWhistle}>
				<WhistleContent
					whistle={whistle}
					setWhistle={setWhistle}
				/>
			</RenderIf>
			<RenderIf condition={recordWhistle}>
				<RecordAudio
					setFiles={setFiles}
				/>
			</RenderIf>
		</>
	)
}

const MeetingDetails = ({ setWhistle, whistle }) => {
	const [showMeetingDetails, setShowMeetingDetails] = useState(false)

	return (<>
		<div className="form-switch my-4">
			<input className="form-check-input me-4"
				type="checkbox"
        id={"meetingCheckbox"}
				checked={showMeetingDetails}
				onChange={() => setShowMeetingDetails(!showMeetingDetails)} />
			<label><T>Request meeting</T></label>
		</div>
		<RenderIf condition={showMeetingDetails}>
			<Input
				placeholder={<T>fill in some details</T>}
        id={"mettingDetails"}
				onChange={(meeting_details) => setWhistle({...whistle, meeting_details})}
				type="text"
			/>
		</RenderIf>
	</>)
}

const formatWhistleContent = (whistle) => {
	let whistleContent = "Content: \n"
	whistleContent += whistle.content
	if(whistle["email"] || whistle["phone_number"] || whistle["name"]){
		whistleContent += "\n\nContact information: \n"
		if(whistle["name"]) whistleContent += "name: " + whistle["name"] + "\n"
		if(whistle["email"]) whistleContent += "email: " + whistle["email"] + "\n"
		if(whistle["phone_number"]) whistleContent += "phone number: " + whistle["phone_number"]
	}

	if(whistle.meeting_details){
		whistleContent += "\n\nRequest for physical meeting:"
		whistleContent += "\n" + whistle.meeting_details
	}

	return {...whistle, content: whistleContent}
}

const StepTwo = ({
	whistle,
	setWhistle,
	recipients,
	previousStep,
	submitWhistle,
	submitBtnDisabled,
	...props
}) => {
	const [files, setFiles] = useState([])

	const handleSubmitWhistle = () => {
		const formattedWhistle = formatWhistleContent(whistle)
		submitWhistle(formattedWhistle, files)
	}

	return (
		<Container>
			<Row>
				<Col xs={12} lg={7} className="mx-auto">
					<div className="d-flex flex-column mx-2">
						<Header />
						<div>
							<InputMode
								setFiles={setFiles}
								whistle={whistle}
								setWhistle={setWhistle}
							/>
							<WhistleRecipient
								recipients={recipients}
								whistle={whistle}
								setWhistle={setWhistle}
							/>
							<DropLoadWrapper>
								<DropLoad
									files={files}
									setFiles={setFiles}
								/>
							</DropLoadWrapper>
							<MeetingDetails
								whistle={whistle}
								setWhistle={setWhistle}
							/>
							<div className="text-center my-5">
								<button className={`btn me-4`} onClick={() => previousStep()} >
									<span className="px-3"> <T>Back</T> </span>
								</button>
								<button className={`btn btn_green`} onClick={handleSubmitWhistle} disabled={submitBtnDisabled} >
									<span className="px-3"> <T>Submit</T> </span>
								</button>
							</div>
						</div>
					</div>
				</Col>
			</Row>
		</Container>
	);
}

export { StepTwo }
